<template>
  <div>
    <div id="testRange" style="width: 100%; height: 100%; background: white">
      <h1>监考视频</h1>
      <video id="video" ref="video" width="100%" playsinline autoplay video></video>
    </div>
    <!--确认-->

    <van-button type="info" v-if="StateCode == 0">等待连接</van-button>
    <van-button type="info" v-if="StateCode == 1">连接成功，等待开始</van-button>
    <van-button type="primary" v-if="StateCode == 2">正在录制视频，请勿操作</van-button>
    <van-button type="danger" v-if="StateCode == 3">考试端离线，请重新扫码连接</van-button>
    <van-button type="primary" v-if="StateCode == 4">正在上传考试视频</van-button>
    <van-button type="primary" v-if="StateCode == 5">视频上传成功，可以退出该页面</van-button>
    <van-overlay :show="StateCode == 2">
      <van-loading size="24px">正在录制考生答题记录，请保存镜头对准考生，请勿进行其他操作...</van-loading>
    </van-overlay>
    <van-overlay :show="StateCode == 4">
      <van-loading size="24px">正在将录制视频进行上传，请勿进行其他操作</van-loading>
    </van-overlay>
    <!--     
    <Button type="primary" @click="photograph">拍照</Button>
    <button type="primart" @click="recorders">录像</button>
    <button type="primart" @click="stopRecorder">停止</button> -->
  </div>
</template>
<script src="https://www.webrtc-experiment.com/screenshot.js"></script>

<script>
import oss from '@/Utils/oss.js';
import { GetSTSToken } from '@/api/public';
import signalInfo from '@u/signalR.js';
import RecordRTC from 'recordrtc';
export default {
  data() {
    return {
      recorder: null,
      source: null,
      MasterConnectionId: '',
      StateCode: 0,
      FileName: '',
      IsTest: 1,
    };
  },
  mounted() {
    if (!this.$route.query.Context || this.$route.query.Context == '') {
      this.$toast.fail('请扫描考试设备上的二维码');
      return;
    }
    if (!this.$route.query.MasterConnectionId || this.$route.query.MasterConnectionId == '') {
      this.$toast.fail('考试设备信息不正确');
      return;
    }
    this.$toast.fail('请下载黔音在线APP进行听力考试');
    return;
    this.IsTest = this.$route.query.IsTest && this.$route.query.IsTest != 1 ? 0 : 1;
    this.FileName = this.$route.query.FileName;
    this.MasterConnectionId = this.$route.query.MasterConnectionId;
    this.callCamera();
  },
  methods: {
    ConnectServer(GroupName) {
      let signal = signalInfo.createNew(GroupName);
      signal
        .start()
        .then(result => {
          console.log('连接成功');
          signal.invoke('AddToGroup', GroupName); //加入在线组
          // 发送摄像设备上线消息
          signal.invoke('GroupMessage', 'Video', 'connection', GroupName); //加入在线组
          this.StateCode = 1;
        })
        .catch(err => {
          console.log(err);
          this.$toast.fail('连接服务器失败，请稍后再试');
        });

      signal.on('GroupMessage', (user, message) => {
        console.log('user :>> ', user);
        console.log('message :>> ', message);
        switch (message) {
          case 'Start':
            this.StateCode = 2;
            this.recorders();
            this.$toast('开始录制');
            console.log('开始录制');
            break;
          case 'End':
            this.StateCode = 4;
            this.stopRecorder(false);
            this.$toast('结束录制，进行上传');
            console.log('结束录制，进行上传');
            break;

          default:
            break;
        }
      });

      signal.on('BroadcastMessage', (user, message) => {
        console.log('user :>> ', user);
        console.log('message :>> ', message);
        switch (message) {
          case 'Offline':
            if (this.StateCode != 4 && user == this.MasterConnectionId) {
              this.StateCode = 3;
              this.$toast('考试端离线，请重新扫码连接');
              console.log('考试端离线');
              this.stopRecorder(true);
            }
            break;

          default:
            break;
        }
      });
    },
    // 调用摄像头
    callCamera() {
      if (window.stream) {
        window.stream.getTracks().forEach(track => {
          track.stop();
        });
      }
      if (!navigator.mediaDevices) {
        this.$toast.fail('摄像头开启失败，请检查摄像头是否可用！');
        return;
      }
      // H5调用电脑摄像头API
      navigator.mediaDevices
        .getUserMedia({
          video: {
            width: { max: 1280 },
            height: { max: 720 },
            facingMode: { exact: 'environment' },
          },
          audio: true,
        })
        .then(success => {
          this.source = success;
          // 摄像头开启成功
          this.$refs['video'].srcObject = success;
          // 实时拍照效果
          this.$refs['video'].play();
          this.$refs['video'].volume = 0;
          this.ConnectServer(this.$route.query.Context);
        })
        .catch(error => {
          this.$toast.fail('摄像头开启失败，请检查摄像头是否可用！');
        });
    },
    // 开始录像
    recorders() {
      //var finalStream = new MediaStream();
      var elementToShare = this.source;
      this.recorder = RecordRTC(elementToShare, {
        type: 'video',
      });
      this.recorder.startRecording();
      // release camera on stopRecording
    },
    // 结束录像
    stopRecorder(Upload = false) {
      if (IsTest == 1) {
        alert('练习考试无需上传考试视频，练习结束');
        return;
      }
      console.log(this.recorder);
      let show = this;
      if (this.recorder) {
        this.recorder.stopRecording(() => {
          let blob = this.recorder.getBlob();

          console.log('blob :>> ', blob);
          if (Upload) {
            return;
          }
          this.upbolb(blob);
          return;
        });
      } else {
        alert('请先打开摄像头');
      }
    },
    upbolb(blob) {
      let show = this;
      if (blob.size < 1000) {
        this.$toast.fail('录制的视频不正确，请重新参加考试');
        return;
      }
      GetSTSToken().then(res => {
        this.pshow = true;
        var ss = oss
          .ossUploadBlob({
            region: res.OtherMsg.Region,
            accessKeyId: res.OtherMsg.AccessKeyId,
            accessKeySecret: res.OtherMsg.AccessKeySecret,
            bucket: res.OtherMsg.BucketName,
            stsToken: res.OtherMsg.SecurityToken,
            blob: blob,
            fileName: `${this.FileName}.webm`,
          })
          .then(res => {
            show.StateCode = 5;
            console.log('res :>> ', res);
          })
          .catch(() => {
            show.$toast.fail('监考视频上传失败，正在重新上传');
            show.upbolb(blob);
            return;
          });
      });
    },
    // 拍照
    photograph() {
      let ctx = this.$refs['canvas'].getContext('2d');
      // 把当前视频帧内容渲染到canvas上
      ctx.drawImage(this.$refs['video'], 0, 0, 640, 480);
      // 转base64格式、图片格式转换、图片质量压缩---支持两种格式image/jpeg+image/png
      let imgBase64 = this.$refs['canvas'].toDataURL('image/jpeg', 0.7);

      /**------------到这里为止，就拿到了base64位置的地址，后面是下载功能----------*/

      // 由字节转换为KB 判断大小
      let str = imgBase64.replace('data:image/jpeg;base64,', '');
      let strLength = str.length;
      let fileLength = parseInt(strLength - (strLength / 8) * 2); // 图片尺寸  用于判断
      let size = (fileLength / 1024).toFixed(2);
      console.log(size); // 上传拍照信息  调用接口上传图片 .........
      // 保存到本地
      let ADOM = document.createElement('a');
      ADOM.href = this.headImgSrc;
      ADOM.download = new Date().getTime() + '.jpeg';
      ADOM.click();
    },
    // 关闭摄像头
    closeCamera() {
      if (!this.$refs['video'].srcObject) return;
      let stream = this.$refs['video'].srcObject;
      let tracks = stream.getTracks();
      tracks.forEach(track => {
        track.stop();
      });
      this.$refs['video'].srcObject = null;
    },
  },
};
</script>

<style>
</style>